import BirthdayIcon from "@apps/rewards/components/Icons/EarningRulesIcons/BirthdayIcon.svelte";
import BuyXToGetYIcon from "@apps/rewards/components/Icons/EarningRulesIcons/BuyXToGetYIcon.svelte";
import CreateAccountIcon from "@apps/rewards/components/Icons/EarningRulesIcons/CreateAccountIcon.svelte";
import CustomChannelIcon from "@apps/rewards/components/Icons/EarningRulesIcons/CustomChannelIcon.svelte";
import FacebookIcon from "@apps/rewards/components/Icons/EarningRulesIcons/FacebookIcon.svelte";
import FollowInstagramIcon from "@apps/rewards/components/Icons/EarningRulesIcons/FollowInstagramIcon.svelte";
import LeaveReviewIcon from "@apps/rewards/components/Icons/EarningRulesIcons/LeaveReviewIcon.svelte";
import NewsletterSubscribeIcon from "@apps/rewards/components/Icons/EarningRulesIcons/NewsletterSubscribeIcon.svelte";
import PlaceOrderIcon from "@apps/rewards/components/Icons/EarningRulesIcons/PlaceOrderIcon.svelte";
import PunchCardIcon from "@apps/rewards/components/Icons/EarningRulesIcons/PunchCardIcon.svelte";
import ShareTheSiteIcon from "@apps/rewards/components/Icons/EarningRulesIcons/ShareTheSiteIcon.svelte";
import SpendXToGetYIcon from "@apps/rewards/components/Icons/EarningRulesIcons/SpendXToGetYIcon.svelte";
import TikTokIcon from "@apps/rewards/components/Icons/EarningRulesIcons/TikTokIcon.svelte";
import TwitterIcon from "@apps/rewards/components/Icons/EarningRulesIcons/TwitterIcon.svelte";
import YouTubeIcon from "@apps/rewards/components/Icons/EarningRulesIcons/YouTubeIcon.svelte";
import type { ComponentType } from "svelte";

import { REWARDS_EARNING_RULE_TYPES } from "./constants";
import type { REWARDS_EARNING_RULE_TYPE } from "./types";

export const REWARDS_EARNING_RULE_ICONS: Record<
    REWARDS_EARNING_RULE_TYPE,
    ComponentType
> = {
    [REWARDS_EARNING_RULE_TYPES.createAccount]: CreateAccountIcon,
    [REWARDS_EARNING_RULE_TYPES.placeOrder]: PlaceOrderIcon,
    [REWARDS_EARNING_RULE_TYPES.leaveReview]: LeaveReviewIcon,
    [REWARDS_EARNING_RULE_TYPES.newsletterSubscribe]: NewsletterSubscribeIcon,
    [REWARDS_EARNING_RULE_TYPES.birthdayGift]: BirthdayIcon,
    [REWARDS_EARNING_RULE_TYPES.instagramFollow]: FollowInstagramIcon,
    [REWARDS_EARNING_RULE_TYPES.facebookPageVisit]: FacebookIcon,
    [REWARDS_EARNING_RULE_TYPES.facebookShare]: FacebookIcon,
    [REWARDS_EARNING_RULE_TYPES.twitterFollow]: TwitterIcon,
    [REWARDS_EARNING_RULE_TYPES.twitterShare]: TwitterIcon,
    [REWARDS_EARNING_RULE_TYPES.punchCard]: PunchCardIcon,
    [REWARDS_EARNING_RULE_TYPES.goalSpend]: SpendXToGetYIcon,
    [REWARDS_EARNING_RULE_TYPES.socialShare]: ShareTheSiteIcon,
    [REWARDS_EARNING_RULE_TYPES.buyXToGetY]: BuyXToGetYIcon,
    [REWARDS_EARNING_RULE_TYPES.customAction]: CreateAccountIcon,
    [REWARDS_EARNING_RULE_TYPES.followOnTikTok]: TikTokIcon,
    [REWARDS_EARNING_RULE_TYPES.followOnYouTube]: YouTubeIcon,
    [REWARDS_EARNING_RULE_TYPES.followOnCustom]: CustomChannelIcon,
};
